"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _stores = require("@seedlang/stores");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var LeagueShowWrapper = function LeagueShowWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _this.onRefresh = function () {
        if (_this.state.refreshing) {
          return;
        }
        _this.setState({
          refreshing: true
        }, _this.refreshUserAndLeague);
      };
      _this.refreshUserAndLeague = function () {
        var _this$params;
        var requests = [];
        var userId = _this.userId;
        var leagueId = _this.leagueId;
        var requestedLeagueId = (_this$params = _this.params) === null || _this$params === void 0 ? void 0 : _this$params.leagueId;
        if (_this.userIsAuthUser) {
          requests.push(new Promise(function (resolve) {
            _state.AppUI.loadUser(null, {
              forceRefresh: true,
              successCallback: resolve,
              failureCallback: resolve
            });
          }));
        } else if ((0, _utils.isPresent)(userId)) {
          requests.push(new Promise(function (resolve) {
            _state.AppUI.userStore.getShow({
              ids: {
                userId: userId
              }
            }, resolve, {
              failureCallback: resolve
            });
          }));
        }
        if ((0, _utils.isPresent)(requestedLeagueId) && requestedLeagueId === leagueId) {
          requests.push(new Promise(function (resolve) {
            _stores.LeagueStore.getShow({
              ids: {
                leagueId: leagueId
              }
            }, resolve, {
              failureCallback: resolve
            });
          }));
        }
        Promise.all(requests).then(function () {
          return _this.setState({
            refreshing: false
          });
        });
      };
      _this.state = {
        refreshing: false
      };
      _this.ensureUserAndLeagueLoaded(props);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _prevProps$user, _this$paramsForProps, _prevProps$league, _this$paramsForProps2;
        if ((((_prevProps$user = prevProps.user) === null || _prevProps$user === void 0 ? void 0 : _prevProps$user.id) || ((_this$paramsForProps = this.paramsForProps(prevProps)) === null || _this$paramsForProps === void 0 ? void 0 : _this$paramsForProps.userId) || _state.AppUI.user.id) !== this.userId || (((_prevProps$league = prevProps.league) === null || _prevProps$league === void 0 ? void 0 : _prevProps$league.id) || ((_this$paramsForProps2 = this.paramsForProps(prevProps)) === null || _this$paramsForProps2 === void 0 ? void 0 : _this$paramsForProps2.leagueId)) !== this.leagueId) {
          this.ensureUserAndLeagueLoaded(this.props);
        }
      }
    }, {
      key: "ensureUserAndLeagueLoaded",
      value: function ensureUserAndLeagueLoaded(props) {
        var _props$user, _props$league, _AppUI$user, _AppUI$userStore$show, _AppUI$user2, _props$user2, _AppUI$user$currentLe, _LeagueStore$showData;
        var params = this.paramsForProps(props);
        var userId = ((_props$user = props.user) === null || _props$user === void 0 ? void 0 : _props$user.id) || (params === null || params === void 0 ? void 0 : params.userId) || _state.AppUI.user.id;
        var requestedLeagueId = ((_props$league = props.league) === null || _props$league === void 0 ? void 0 : _props$league.id) || (params === null || params === void 0 ? void 0 : params.leagueId);
        if ((_AppUI$user = _state.AppUI.user) !== null && _AppUI$user !== void 0 && _AppUI$user.admin && userId !== _state.AppUI.user.id && (0, _utils.isBlank)(props.user) && ((_AppUI$userStore$show = _state.AppUI.userStore.showData) === null || _AppUI$userStore$show === void 0 ? void 0 : _AppUI$userStore$show.id) !== userId) {
          _state.AppUI.userStore.getShow({
            ids: {
              userId: userId
            }
          });
        }
        if ((_AppUI$user2 = _state.AppUI.user) !== null && _AppUI$user2 !== void 0 && _AppUI$user2.admin && (0, _utils.isPresent)(requestedLeagueId) && requestedLeagueId !== ((_props$user2 = props.user) === null || _props$user2 === void 0 || (_props$user2 = _props$user2.currentLeague) === null || _props$user2 === void 0 ? void 0 : _props$user2.id) && requestedLeagueId !== ((_AppUI$user$currentLe = _state.AppUI.user.currentLeague) === null || _AppUI$user$currentLe === void 0 ? void 0 : _AppUI$user$currentLe.id) && ((_LeagueStore$showData = _stores.LeagueStore.showData) === null || _LeagueStore$showData === void 0 ? void 0 : _LeagueStore$showData.id) !== requestedLeagueId) {
          _stores.LeagueStore.getShow({
            ids: {
              leagueId: requestedLeagueId
            }
          });
        }
      }
    }, {
      key: "paramsForProps",
      value: function paramsForProps(props) {
        var _props$route;
        return _state.AppUI.layout.isNative ? (_props$route = props.route) === null || _props$route === void 0 ? void 0 : _props$route.params : props.params;
      }
    }, {
      key: "league",
      get: function get() {
        var _this$user, _AppUI$user$currentLe2, _LeagueStore$showData2, _this$user2;
        if ((0, _utils.isPresent)(this.props.league)) {
          return this.props.league;
        }
        if (this.leagueId === ((_this$user = this.user) === null || _this$user === void 0 || (_this$user = _this$user.currentLeague) === null || _this$user === void 0 ? void 0 : _this$user.id)) {
          return this.user.currentLeague;
        }
        if (this.leagueId === ((_AppUI$user$currentLe2 = _state.AppUI.user.currentLeague) === null || _AppUI$user$currentLe2 === void 0 ? void 0 : _AppUI$user$currentLe2.id)) {
          return _state.AppUI.user.currentLeague;
        }
        if (this.leagueId === ((_LeagueStore$showData2 = _stores.LeagueStore.showData) === null || _LeagueStore$showData2 === void 0 ? void 0 : _LeagueStore$showData2.id)) {
          return _stores.LeagueStore.showData;
        }
        if (this.userIsAuthUser) {
          return _state.AppUI.user.currentLeague;
        }
        return (_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.currentLeague;
      }
    }, {
      key: "leaguePosition",
      get: function get() {
        var _this$league;
        return (_this$league = this.league) === null || _this$league === void 0 || (_this$league = _this$league.leagueLevel) === null || _this$league === void 0 ? void 0 : _this$league.position;
      }
    }, {
      key: "leagueImageSrc",
      get: function get() {
        return this.leaguePosition ? "/images/leagues/league_".concat(this.leaguePosition, ".png") : null;
      }
    }, {
      key: "userLeague",
      get: function get() {
        var _this$league2,
          _this2 = this;
        return (_this$league2 = this.league) === null || _this$league2 === void 0 || (_this$league2 = _this$league2.userLeagues) === null || _this$league2 === void 0 ? void 0 : _this$league2.find(function (ul) {
          return ul.userId === _this2.userId;
        });
      }
    }, {
      key: "isUsersLastLeague",
      get: function get() {
        var _this$user3, _this$league3, _this$user$currentLea;
        return (0, _utils.isPresent)((_this$user3 = this.user) === null || _this$user3 === void 0 ? void 0 : _this$user3.currentLeague) && ((_this$league3 = this.league) === null || _this$league3 === void 0 ? void 0 : _this$league3.id) === ((_this$user$currentLea = this.user.currentLeague) === null || _this$user$currentLea === void 0 ? void 0 : _this$user$currentLea.id);
      }
    }, {
      key: "userRank",
      get: function get() {
        var _this$userLeague;
        if (!this.user) {
          return null;
        }
        return ((_this$userLeague = this.userLeague) === null || _this$userLeague === void 0 ? void 0 : _this$userLeague.rank) || 0;
      }
    }, {
      key: "totalMembers",
      get: function get() {
        var _this$league4;
        return ((_this$league4 = this.league) === null || _this$league4 === void 0 || (_this$league4 = _this$league4.userLeagues) === null || _this$league4 === void 0 ? void 0 : _this$league4.length) || 0;
      }
    }, {
      key: "userId",
      get: function get() {
        var _this$params2;
        if (this.props.user) {
          return this.props.user.id;
        }
        if ((_this$params2 = this.params) !== null && _this$params2 !== void 0 && _this$params2.userId) {
          return this.params.userId;
        }
        return _state.AppUI.user.id;
      }
    }, {
      key: "leagueId",
      get: function get() {
        var _this$params3, _AppUI$user$currentLe3;
        if (this.props.league) {
          return this.props.league.id;
        }
        if ((_this$params3 = this.params) !== null && _this$params3 !== void 0 && _this$params3.leagueId) {
          return this.params.leagueId;
        }
        return (_AppUI$user$currentLe3 = _state.AppUI.user.currentLeague) === null || _AppUI$user$currentLe3 === void 0 ? void 0 : _AppUI$user$currentLe3.id;
      }
    }, {
      key: "params",
      get: function get() {
        return this.paramsForProps(this.props);
      }
    }, {
      key: "user",
      get: function get() {
        var _AppUI$userStore$show2;
        if (this.userId === _state.AppUI.user.id) {
          return _state.AppUI.user;
        }
        if (this.userId === ((_AppUI$userStore$show2 = _state.AppUI.userStore.showData) === null || _AppUI$userStore$show2 === void 0 ? void 0 : _AppUI$userStore$show2.id)) {
          return _state.AppUI.userStore.showData;
        }
        return null;
      }
    }, {
      key: "userIsAuthUser",
      get: function get() {
        return this.userId === _state.AppUI.user.id;
      }
    }, {
      key: "userIsInLeague",
      get: function get() {
        var _this$league5,
          _this3 = this;
        return (_this$league5 = this.league) === null || _this$league5 === void 0 || (_this$league5 = _this$league5.userLeagues) === null || _this$league5 === void 0 ? void 0 : _this$league5.some(function (ul) {
          return ul.userId === _this3.userId;
        });
      }
    }, {
      key: "leagueEndedText",
      get: function get() {
        var _this$league6;
        return "This league ends in ".concat((_this$league6 = this.league) === null || _this$league6 === void 0 ? void 0 : _this$league6.timeFromNow, ".");
      }
    }, {
      key: "isFirstLeagueMember",
      get: function get() {
        var _this$league7, _this$league8;
        return this.userIsAuthUser && ((_this$league7 = this.league) === null || _this$league7 === void 0 ? void 0 : _this$league7.usersCount) === 1 && !((_this$league8 = this.league) !== null && _this$league8 !== void 0 && _this$league8.ended);
      }
    }, {
      key: "statusText",
      get: function get() {
        var _this$userLeague2, _this$userLeague3, _this$userLeague4, _this$userLeague5, _this$league9, _this$league0;
        // empty string is because by the last league you know how the leagues work
        var rank = "".concat(this.userIsAuthUser ? 'You are' : "".concat((_this$userLeague2 = this.userLeague) === null || _this$userLeague2 === void 0 || (_this$userLeague2 = _this$userLeague2.user) === null || _this$userLeague2 === void 0 ? void 0 : _this$userLeague2.name, " is"), " #").concat((_this$userLeague3 = this.userLeague) === null || _this$userLeague3 === void 0 ? void 0 : _this$userLeague3.rank, ".");
        var status = (_this$userLeague4 = this.userLeague) !== null && _this$userLeague4 !== void 0 && _this$userLeague4.demoted ? 'Oh no! You are in danger of being demoted.' : (_this$userLeague5 = this.userLeague) !== null && _this$userLeague5 !== void 0 && _this$userLeague5.promoted ? 'Congrats, you are in the promotion zone!' : ((_this$league9 = this.league) === null || _this$league9 === void 0 || (_this$league9 = _this$league9.leagueLevel) === null || _this$league9 === void 0 ? void 0 : _this$league9.promotionCount) === 0 ? '' : "The first ".concat((_this$league0 = this.league) === null || _this$league0 === void 0 || (_this$league0 = _this$league0.leagueLevel) === null || _this$league0 === void 0 ? void 0 : _this$league0.promotionCount, " will be promoted to the next league.");
        return "".concat(rank, " ").concat(status);
      }
    }, {
      key: "leagueEndedStatusText",
      get: function get() {
        if ((0, _utils.isPresent)(this.userLeague)) {
          var _this$userLeague$user, _this$userLeague6, _this$league1;
          return "".concat(this.userIsAuthUser ? 'You' : (_this$userLeague$user = this.userLeague.user) === null || _this$userLeague$user === void 0 ? void 0 : _this$userLeague$user.name, " finished #").concat((_this$userLeague6 = this.userLeague) === null || _this$userLeague6 === void 0 ? void 0 : _this$userLeague6.rank, ",").concat(this.userLeague.promoted ? " and ".concat(this.userIsAuthUser ? 'were' : 'was', " promoted to the next league.") : this.userLeague.demoted ? " and ".concat(this.userIsAuthUser ? 'were' : 'was', " demoted to the previous league.") : " and will stay in the ".concat((_this$league1 = this.league) === null || _this$league1 === void 0 || (_this$league1 = _this$league1.leagueLevel) === null || _this$league1 === void 0 ? void 0 : _this$league1.name, "."));
        }
        return '';
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          league: this.league,
          user: this.user,
          leaguePosition: this.leaguePosition,
          leagueImageSrc: this.leagueImageSrc,
          userRank: this.userRank,
          totalMembers: this.totalMembers,
          userId: this.userId,
          userIsAuthUser: this.userIsAuthUser,
          userLeague: this.userLeague,
          isUsersLastLeague: this.isUsersLastLeague,
          userIsInLeague: this.userIsInLeague,
          firstLeagueMemberText: "You are the first member of this league. New members will be added soon!",
          isFirstLeagueMember: this.isFirstLeagueMember,
          leagueEndedText: this.leagueEndedText,
          statusText: this.statusText,
          leagueEndedStatusText: this.leagueEndedStatusText,
          refreshing: this.state.refreshing,
          onRefresh: this.onRefresh
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "league", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "league"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "leaguePosition", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "leaguePosition"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "leagueImageSrc", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "leagueImageSrc"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userLeague", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userLeague"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isUsersLastLeague", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isUsersLastLeague"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userRank", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userRank"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "totalMembers", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "totalMembers"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "leagueId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "leagueId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "params", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "params"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "user"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userIsAuthUser", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userIsAuthUser"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userIsInLeague", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userIsInLeague"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "leagueEndedText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "leagueEndedText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isFirstLeagueMember", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isFirstLeagueMember"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "statusText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "statusText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "leagueEndedStatusText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "leagueEndedStatusText"), _class2.prototype), _class2)) || _class;
};
LeagueShowWrapper.displayName = 'LeagueShowWrapper';
var _default = exports["default"] = LeagueShowWrapper;